/**
 * Labstep
 *
 * @module components/UserGroup/Action/Create
 * @desc Action to create a user group
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { UserGroup } from 'labstep-web/models/user-group.model';
import type React from 'react';
import type { IUserGroupActionCreateProps } from './types';

export const UserGroupActionCreate: React.FC<
  IUserGroupActionCreateProps
> = ({
  group,
  authenticatedUserEntity,
  actionComponentProps,
  redirectRoute,
}) => (
  <EntityActionCreate
    entityName={UserGroup.entityName}
    body={{ user_id: authenticatedUserEntity.id, group_id: group.id }}
    redirectRoute={redirectRoute}
    actionComponentProps={actionComponentProps}
    skipPermissionCheck
  />
);

export default withAuthenticatedUserEntity(UserGroupActionCreate);
